import { Badge } from "@/components/ui/badge";
import type { ComplaintStatus } from "@/types";

export const COMPLAINT_STATUS_LABELS: Record<ComplaintStatus, string> = {
  OPEN: "Open",
  INVESTIGATING: "Investigating",
  RESOLVED: "Resolved",
  REJECTED: "Rejected",
};

const VARIANTS: Record<ComplaintStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  OPEN: "destructive",
  INVESTIGATING: "warning",
  RESOLVED: "success",
  REJECTED: "outline",
};

export function ComplaintStatusBadge({ status }: { status: ComplaintStatus }) {
  return <Badge variant={VARIANTS[status] || "outline"}>{COMPLAINT_STATUS_LABELS[status] || status}</Badge>;
}
